export const rulesViolated = {
    moneyLaundry: 'Hvitvasking',
    fraud: 'Bedrageri',
    forgery: 'Falskneri',
    theft: 'Tyveri',
    secondOffence: 'Annet lovbrudd',
    dontKnow: 'Vet ikke',
};
